import {
  Icon,
  Track,
  WrapTrack,
  Container,
  ButtonMarker
} from './FieldWeight.styles';
import content from './content';
import type { TouchEvent } from 'react';
import { useTranslation } from '@CS/hooks';

import IconWeightSmall from '@/assets/images/icons/icon-weight-small.svg?component';
import IconWeightMedium from '@/assets/images/icons/icon-weight-medium.svg?component';
import IconWeightLarge from '@/assets/images/icons/icon-weight-large.svg?component';

interface props {
  onChange: (value: number) => void;
  value: number;
}

const FieldWeight: React.FC<props> = ({ value, onChange }) => {
  const label = useTranslation(content);
  const handleSetCurrentValue = (_value: number) =>
    _value !== value && onChange(_value);

  const onHandleChange = (e: TouchEvent) => {
    const rect = e.currentTarget.getBoundingClientRect();

    const x =
      e.targetTouches[0].pageX -
      (rect.left + document.documentElement.scrollLeft);

    const value = (x / rect.width) * 100;

    /**/ if (value < 33.33) handleSetCurrentValue(1);
    else if (value > 66.66) handleSetCurrentValue(3);
    else handleSetCurrentValue(2);
  };

  return (
    <Container onTouchStart={onHandleChange} onTouchMove={onHandleChange}>
      <span>{label}</span>

      <Icon $currentValue={value} $value={1}>
        <IconWeightSmall />
      </Icon>

      <Icon $currentValue={value} $value={2}>
        <IconWeightMedium />
      </Icon>

      <Icon $currentValue={value} $value={3}>
        <IconWeightLarge />
      </Icon>

      <WrapTrack>
        <Track />
        <ButtonMarker $value={(value - 1) * 50} />
      </WrapTrack>
    </Container>
  );
};

export default FieldWeight;
